import { useEffect, useState } from 'react'
import { ENTITY_TYPES } from '@sales-center/common'
import { useAppDispatch } from '@user/store/hooks'
import {
  useSchedulingWizard,
  setCloseableActionCreator as setClosable,
} from '../wizardContext'
import { getOpportunityIsCloseable } from '@user/store/opportunity'

export function useCheckCloseOnSchedule(props: {
  entityId: number
  entityType: ENTITY_TYPES
}) {
  const { entityId, entityType } = props

  const [{ mode }, dispatch] = useSchedulingWizard()

  const appDispatch = useAppDispatch()
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const execute = async () => {
      setLoading(true)

      const result = await appDispatch(getOpportunityIsCloseable(entityId))

      if (getOpportunityIsCloseable.fulfilled.match(result)) {
        const { closeRequirements } = result.payload
        const missingRequirements = closeRequirements.filter(
          (x) => x.type !== 'Service Scheduled',
        ).length
        dispatch(setClosable(missingRequirements === 0))
      }

      setLoading(false)
    }

    const checkClosable =
      mode === 'service' && entityType === ENTITY_TYPES.Opportunity

    if (checkClosable) {
      execute()
    } else {
      setLoading(false)
      dispatch(setClosable(false))
    }
  }, [appDispatch, dispatch, entityId, entityType, mode])

  return loading
}
